<pl-spider-chart *ngIf="block && block.data" [title]="block.data.title" [axes]="block.data.set[0].axes" />
